import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import { GenericHttpService } from "../../../../services/generic-http.service";
import * as HSET from "./../../../../constants/graph.settings";
import { Observable } from "rxjs";

@Injectable()
export class RegionWiseOtifBreakupService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  buckets;
  partedData;
  constructor(public generic: GenericHttpService) {}

  getRegionWiseOtifBreakupData(url, params): Observable<any> {
    const option = {
      method: "GET",
      url: url, // "./assets/data/p-d-reason.json",
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processRegionWiseOtifBreakup.bind(this))
    );
  }

  processRegionWiseOtifBreakup(data: any) {
    if (data.data.length === 0) return null;

    const processedData = this.drillDownData(data.data);
    const __v2Data = processedData["data"];
    const dataKeys = processedData["dataKeys"];

    const oldData = [];
    dataKeys.map(__value => {
      __v2Data[__value].data.map(__data => {
        oldData.push({
          key: __value,
          bucket: __data.bucket,
          volume: __data.volume,
          percentage: __data.percentage
        });
      });
    });
    const buckets = Array.from(new Set(oldData.map(x => x.bucket)));
    const partedData = buckets.map(bucket => {
      return oldData.filter(row => row.bucket === bucket);
    });
    return { data: oldData, buckets, partedData };
  }

  drillDownData(data) {
    let dataKeys = [];
    let allKey = "All";
    let dataObject = { ...(data["data"] || null) };
    delete data["data"];
    if (Object.keys(data).length > 1) {
      dataKeys = Object.keys(data);
    } else if (Object.keys(data).length === 1) {
      allKey = Object.keys(data)[0];
      data = data[Object.keys(data)[0]];
      dataObject = { ...data["data"] };
      delete data["data"];
      if (Object.keys(data).length > 1) {
        dataKeys = Object.keys(data);
      } else if (Object.keys(data).length === 1) {
        allKey = Object.keys(data)[0];
        data = data[Object.keys(data)[0]];
        dataObject = { ...data["data"] };
        delete data["data"];
        dataKeys = Object.keys(data);
      }
    }
    return { data, dataKeys, dataObject, allKey };
  }

  processPartForChart(part) {
    if (!part) return {};
    const volume = part.map(aregion => aregion.volume);
    const region = part.map(aregion => aregion.key);
    const percentage = part.map(aregion =>
      Number(aregion.percentage.toFixed(2))
    );
    return { percentage, volume, region };
  }

  createChart(chartData, Options) {
    const chart = JSON.parse(JSON.stringify(HSET.dualBar));
    chart.series[0].data = chartData.percentage;
    chart.series[1].data = chartData.volume;
    chart.xAxis[0].categories = chartData.region;

    chart.series[1].name = "Quantity";
    chart.yAxis[0].title.text = Options.yaxis[0];
    chart.yAxis[1].title.text = Options.yaxis[1];

    return chart;
  }
}
